<template>
    <div>
        <v-data-table v-if="!showEmail" disable-initial-sort
                      :headers="headers" :items="items" class="elevation-1 gru-table fixed-header"
                      :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination">
            <template slot="headers">
                <tr>
                    <th v-for="header in headers" :width="header.width">
                        <div :style="header.headerStyle">
                            {{$t(header.text)}}
                        </div>
                    </th>
                </tr>
            </template>
            <template v-slot:items="props">
                <tr :key="props.index">
                    <td class="text-xs-center" >{{ props.index+1 + parseInt(pagination.page-1) *
                        parseInt(pagination.rowsPerPage)}}
                    </td>
                    <td class="text-xs-left">
                        {{ props.item.task }}
                    </td>
                    <td class="text-xs-left">
                        <input type="text" class="tableInput" v-model="props.item.documentCode"/>
                    </td>
                    <td class="text-xs-left">
                        <input type="text" class="tableInput" v-model="props.item.documentName"/>
                    </td>
                    <!--td class="text-xs-left">{{ getStatusName(props.item.status) }}</td-->
                    <td align="center">
                        <i-upload label=""
                                  v-model="props.item.documentId"
                                  file-type="attach" :multifile="false"
                                  accept=".docx"
                                  :key="'document_'+props.index+props.item.procDocId"
                                  :name="'document_'+props.index+props.item.procDocId"
                                  :data-vv-as="$t('lang.procedure.document')"
                                  :error-messages="errors.first('document')"
                        />
                    </td>
                    <td align="center">
                        <v-btn depressed outline icon fab dark :color="getMailColor(props.item.emailTemplate)" small @click="onEmail(props.item)"
                               title="Email">
                            <v-icon>email</v-icon>
                        </v-btn>
                    </td>
                    <td align="center">
                        <v-btn depressed outline icon fab dark color="red" small @click="onClear(props.item)"
                               title="Clear">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <ckeditor :editor="editor" v-model="editorData" :config="editorConfig" type="inline"
                  v-if="showEmail"></ckeditor>
        <div style="text-align: right">
            <v-spacer></v-spacer>
            <v-btn dark class="primary" @click="onSave" width="200">
                {{ $t('lang.common.save') }}
            </v-btn>
            <v-btn @click="onCancel" width="200">
                {{$t("lang.common.cancel")}}
            </v-btn>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {CrudService} from "@/services";
    import {message} from "@/shared/message";
    import Validator from "../../../../public/js/validator";
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import IUpload from "../../../components/form/Upload";

    export default {
        name: "procedure-document",
        components: {IUpload},
        props: {
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 20, 30, 40, 50]
            },
        },

        data: () => ({
            procedure: null,
            showList: true,
            sortField: "teacherName",
            orderBy: "asc",
            headers: [
                {
                    text: "lang.common.no",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "name",
                    width: "5%"
                },
                {
                    text: "lang.procedure.taskName",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "task",
                    width: "25%"
                },
                {
                    text: "lang.procedure.documentCode",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "documentCode",
                    width: "10%"
                },
                {
                    text: "lang.procedure.documentName",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "documentName",
                    width: "20%"
                },
                {
                    text: "lang.procedure.documentTemplate",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "teacherId",
                    width: "20%"
                },
                {
                    text: "lang.procedure.mailTemplate",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "teacherId",
                    width: "10%"
                },
                {
                    text: "lang.common.clear",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "studentId",
                    width: "10%"
                }
            ],
            items: [],
            search: "",
            err: {
                fullName: [],
                phone: [],
                email: []
            },
            editingItem: null,
            editorData: "",
            pagination: {
                rowsPerPage: 10,
                page: 1,
                totalItems: 0,
            },
            editor: ClassicEditor,
            editorData: '',
            editorConfig: {
                // The configuration of the editor.
                height:700
            },
            showEmail: false,
        }),

        watch: {},

        created() {
        },
        methods: {
            getMailColor(template){
                if(template == undefined || template == null || template.trim() == ""){
                    return "orange";
                }   else {
                    return "blue";
                }
            },

            viewProcedureDocument(item) {
                this.procedure = item;
                this.getDocument();
            },

            getDocument() {
                axios.post(process.env.VUE_APP_API_URL + "/procedure/document/list", this.procedure).then(
                    data => {
                        this.$nextTick(
                            () => {
                                this.items = data;
                                this.pagination.totalItems = this.items.length;
                                console.log(this.editor);
                            }
                        )
                    }
                )
            },

            onEmail(item) {
                this.editingItem = item;
                this.editorData = item.emailTemplate;
                this.showEmail = true;
            },

            onSave() {
                if (this.showEmail) {
                    this.editingItem.emailTemplate = this.editorData;
                    axios.post(process.env.VUE_APP_API_URL + "/procedure/document/save", this.editingItem).then(
                        data => {
                            if (data.success) {
                                message.success(this.$t("lang.common.update_success"));
                                this.getDocument();
                                this.onCancel();
                            } else {
                                message.error(data.description);
                            }
                        }
                    )
                } else {
                    axios.post(process.env.VUE_APP_API_URL + "/procedure/document/saveAll", this.items).then(
                        data => {
                            if (data.success) {
                                message.success(this.$t("lang.common.update_success"));
                                this.getDocument();
                                this.onCancel();
                            } else {
                                message.error(data.description);
                            }
                        }
                    )
                }
            },

            onCancel() {
                if (this.showEmail) {
                    this.showEmail = false;
                } else {
                    this.$emit("cancel");
                }
            }


        }
    };
</script>